'use strict';

var DeleteRoleDirective = function DeleteRoleDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/delete-role.html'),
    controller: 'DeleteRoleController',
    scope: {
      roleName: '='
    },
    link: function link($scope, element) {
      $scope.hideModal = function () {
        element.modal('hide');
      };
    }
  };
};
DeleteRoleDirective.$inject = [];
module.exports = DeleteRoleDirective;